import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Star, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const Stars = ({ n, size = 16 }) => (
  <span style={{ display: 'inline-flex', gap: 2 }}>
    {[1, 2, 3, 4, 5].map((i) => <Star key={i} style={{ width: size, height: size, color: '#f5b301', fill: i <= Math.round(n) ? '#f5b301' : 'transparent' }} />)}
  </span>
);

const Summary = ({ data }) => (
  <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '1.25rem 1.5rem', marginBottom: '1.5rem' }}>
    <div>
      <p data-testid="reviews-average" style={{ fontSize: '2.5rem', fontWeight: 800, color: '#2D3748', lineHeight: 1 }}>{data.average.toFixed(1)}</p>
      <Stars n={data.average} size={20} />
      <p data-testid="reviews-total" style={{ fontSize: '0.85rem', color: '#718096', marginTop: 4 }}>{data.total} avaliação(ões)</p>
    </div>
    <div style={{ flex: 1, minWidth: 220 }}>
      {[5, 4, 3, 2, 1].map((i) => {
        const c = data.distribution[String(i)] || 0;
        return (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: '0.8rem', color: '#4a5568', marginBottom: 4 }}>
            <span style={{ width: 14 }}>{i}</span><Star style={{ width: 12, height: 12, color: '#f5b301', fill: '#f5b301' }} />
            <div style={{ flex: 1, height: 8, background: '#edf2f7', borderRadius: 4 }}>
              <div style={{ width: `${data.total ? (c / data.total) * 100 : 0}%`, height: '100%', background: '#f5b301', borderRadius: 4 }} />
            </div>
            <span data-testid={`reviews-dist-${i}`} style={{ width: 28, textAlign: 'right' }}>{c}</span>
          </div>
        );
      })}
    </div>
  </div>
);

export const AdminReviews = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/admin/reviews`, { headers: authHeaders() }).then((r) => setData(r.data)).catch(() => setData({ reviews: [], total: 0, average: 0, distribution: {} }));
  }, []);
  return (
    <div data-testid="admin-reviews-page">
      <h1 style={{ fontSize: '1.75rem', fontWeight: 700, color: '#2D3748', marginBottom: '1.5rem' }}>Avaliações da plataforma</h1>
      {!data ? <Loader2 className="w-6 h-6 animate-spin" /> : (
        <>
          <Summary data={data} />
          {data.reviews.length === 0 ? <p data-testid="reviews-empty" style={{ color: '#718096' }}>Nenhuma avaliação recebida.</p> : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              {data.reviews.map((r) => (
                <div key={r.id} data-testid={`review-card-${r.id}`} style={{ background: 'white', border: '1px solid #e2e8f0', borderRadius: 12, padding: '1rem 1.25rem' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem', flexWrap: 'wrap' }}>
                    <div>
                      <p style={{ fontWeight: 600, color: '#2D3748' }}>{r.nome || '-'} <span style={{ fontWeight: 400, color: '#718096', fontSize: '0.8rem' }}>({r.actor_type}) · {r.email}</span></p>
                      {r.editor_nome && <p style={{ fontSize: '0.78rem', color: '#718096' }}>{r.actor_type === 'editor' ? 'Editora' : 'Catálogo'}: {r.editor_nome}</p>}
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <Stars n={r.rating} />
                      <p style={{ fontSize: '0.75rem', color: '#a0aec0' }}>{new Date(r.updated_at).toLocaleString('pt-BR')}</p>
                    </div>
                  </div>
                  {r.comment && <p style={{ marginTop: '0.5rem', color: '#2D3748', fontSize: '0.9rem', whiteSpace: 'pre-wrap' }}>{r.comment}</p>}
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};
